/**
 * Shared formatting for the reliability tables (provider-level and
 * per-model) — both render on related pages and MUST agree on thresholds:
 * the same success rate showing amber in one table and muted in the other
 * reads as a data bug.
 */
import type { AdminProviderHealthWindow } from '@/lib/api';

export const WINDOWS: Array<{ key: AdminProviderHealthWindow; label: string }> = [
  { key: '24h', label: '24 hours' },
  { key: '7d', label: '7 days' },
  { key: '30d', label: '30 days' },
];

export function successTone(rate: number): string {
  if (rate < 0.95) return 'text-red-600 dark:text-red-400 font-semibold';
  if (rate < 0.99) return 'text-amber-600 dark:text-amber-400';
  return 'text-muted-foreground';
}

export function fmtLatency(ms: number | null): string {
  if (ms === null) return '—';
  return ms >= 10_000 ? `${(ms / 1000).toFixed(1)}s` : `${ms.toLocaleString()}ms`;
}

export function topError(errorCounts: Record<string, number>): string {
  const entries = Object.entries(errorCounts);
  if (entries.length === 0) return '—';
  entries.sort(([, a], [, b]) => b - a);
  const [type, count] = entries[0];
  return `${type} (${count})`;
}
